import { Inline } from 'braid-design-system';
import type { FC } from 'react';

import { BUCKETS } from 'src/stores/JobApplicationStore/types';

import type { JobApplicationCardProps } from '../JobApplicationCard';

import { MoveStatusMenu } from './MoveStatusMenu';
import { NotSuitableAndShortlistButtons } from './NotSuitableAndShortlistButtons';

export const ChangeStatusButtons: FC<
  Pick<
    JobApplicationCardProps,
    'jobApplication' | 'currentBucket' | 'changeStatus'
  > & { isFilterExpand: boolean }
> = ({ jobApplication, currentBucket, changeStatus, isFilterExpand }) =>
  currentBucket === BUCKETS.INBOX ? (
    // FIXME: NVL - change to xsmall
    <Inline space="small" alignY="center">
      <MoveStatusMenu
        jobApplication={jobApplication}
        changeStatus={changeStatus}
        currentBucket={currentBucket}
      />

      <NotSuitableAndShortlistButtons
        fullName={jobApplication.fullName}
        changeStatus={changeStatus}
        isFilterExpand={isFilterExpand}
      />
    </Inline>
  ) : (
    <MoveStatusMenu
      jobApplication={jobApplication}
      changeStatus={changeStatus}
      currentBucket={currentBucket}
    />
  );
